import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DoubleArrowsGlyph = /*#__PURE__*/createElement("g", {
  id: "double_arrows"
}, /*#__PURE__*/createElement("path", {
  d: "M55.5,50.3h-27c-0.6,0-1.1,0.3-1.3,0.9c-0.2,0.5-0.2,1.1,0.2,1.6l13.5,15.8c0.3,0.3,0.7,0.5,1.1,0.5s0.8-0.2,1.1-0.5 l13.5-15.8c0.4-0.4,0.5-1,0.2-1.6C56.6,50.6,56.1,50.3,55.5,50.3z"
}), /*#__PURE__*/createElement("path", {
  d: "M28.5,33.7h27c0.6,0,1.1-0.3,1.3-0.9c0.2-0.5,0.2-1.1-0.2-1.6L43.1,15.5c-0.6-0.6-1.7-0.6-2.2,0L27.4,31.3 c-0.4,0.4-0.5,1-0.2,1.6C27.4,33.3,27.9,33.7,28.5,33.7z"
}));
const DoubleArrows = createSvg({
  name: 'double_arrows',
  path: DoubleArrowsGlyph
});

export default DoubleArrows;
export { DoubleArrowsGlyph };
